﻿// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// css
require('../css/main.css');

// Write your JavaScript code.
var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};

mmsystem.utilities = require('mmsystem-utilities');
mmsystem.plugins = require('mmsystem-plugins');
mmsystem.ui.content = require('mmsystem-ui-content');
mmsystem.ui.content.orders = require('mmsystem-ui-content-orders');

// Vendors js

//console.log("app.js ....");

// Export Globals
window.mmsystem = mmsystem;
// hot module
if (module.hot) {
    module.hot.accept();
}